
import Layout from '../../layouts/FullScreenLayout'
import FreeTrial from './FreeTrial'

export default Layout(FreeTrial)